import { render, staticRenderFns } from "./dealerStock.vue?vue&type=template&id=304b81e0&scoped=true"
import script from "./dealerStock.vue?vue&type=script&lang=js"
export * from "./dealerStock.vue?vue&type=script&lang=js"
import style0 from "./dealerStock.vue?vue&type=style&index=0&id=304b81e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b81e0",
  null
  
)

export default component.exports